import { registerLicense } from '@syncfusion/ej2-base';

// key for 30.x.x
const defaultSyncfusionLicense = 'Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXdfc3VVQmNcUURzV0tWYEE=';

// this function is not meant to be a long-term solution, but it's the easiest and least-risky way of allowing our app and all storybook components to easily
// use the same syncfusion license key. see comments in `CommentRichTextEditor.stories.tsx` for more context
export const registerDefaultSyncfusionLicense = () => {
    registerLicense(defaultSyncfusionLicense);
};
